exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swiper-button[data-v-087d3770] {\n  color: #08bc2a;\n  top: 250px;\n}\n", ""]);

// exports
